import { visibleFitReasons } from "../../lib/leadReasons.js";

export function LeadDecisionSummary({
  title,
  excerpt,
  href,
  source,
  freshness,
  budget,
  reasons = [],
  headingLevel = 2,
}) {
  const Heading = `h${Math.min(6, Math.max(1, headingLevel))}`;
  const facts = visibleFitReasons(reasons);
  // Пересказ ИИ и текст заказчика — не одно и то же: пересказ короче втрое.
  // Решение «моё / не моё» человек принимает по словам клиента, поэтому
  // показываем и то и другое, а повтор гасим.
  const body = excerpt && excerpt.trim() && excerpt.trim() !== (title || "").trim()
    ? excerpt
    : null;
  return (
    <article className="lead-decision-summary">
      <div className="lead-decision-summary__meta">
        {[source, freshness].filter(Boolean).map((value) => <span key={value}>{value}</span>)}
      </div>
      <Heading>{title}</Heading>
      {body ? <p className="lead-decision-summary__excerpt">{body}</p> : null}
      {budget ? <strong className="lead-decision-summary__budget">{budget}</strong> : null}
      {facts.length ? (
        <ul>{facts.map((reason) => <li key={reason}>{reason}</li>)}</ul>
      ) : null}
      {href ? (
        <a
          className="lead-decision-summary__origin"
          href={href}
          target="_blank"
          rel="noreferrer noopener"
        >
          Открыть оригинал
        </a>
      ) : null}
    </article>
  );
}
